import UserError from './UserError.js'

export class GetContactTokenUserError extends UserError {}
